import React, { Component } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import { CommonEditButton, DeletePopup, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import { DataGrid } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import { ImagePaths } from '../../../../Utility/ImagePaths';

class DocPainScaleLeft extends Component {
    constructor(props) {
        super(props);
        this.state = {
            painScaleList: [],
            isDeleteClicked: false,
            deleteID: null,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }
    }

    componentDidUpdate(prevprops) {
        if ((prevprops.GetAPiCall !== this.props.GetAPiCall) && this.props.GetAPiCall) { this.GetPainScaleData() }
    }

    GetPainScaleData = () => {
        try {
            RestAPIService.getAll(Serviceurls.IP_PAIN_CHART + `?appointment_id=${this.props?.appointmentId}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState((prevState) => ({
                            ...prevState,
                            painScaleList: response.data.data || []
                        }))
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    onEditHandler = (data) => {
        this.props.EditPainScaleData(data);
    }

    onDeleteHandler = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            isDeleteClicked: true,
            deleteID: data.id,
        }))
    }

    errorMessage = (message) => {
        this.setState((prevState) => ({
            ...prevState,
            isErrorMsg: true,
            isErrorMsgText: message
        }))
    }
    successMessage = (message) => {
        this.setState((prevState) => ({
            ...prevState,
            successMsg: true,
            successMsgText: message
        }))
    }

    msgClose = () => {
        this.setState((prevState) => ({
            ...prevState,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }))
    }
    popupClose = () => {
        this.setState((prevState) => ({
            ...prevState,
            isDeleteClicked: false,
            deleteID: null,
        }))
    }
    deletePainScale = () => {
        try {
            RestAPIService.delete(Serviceurls.IP_PAIN_CHART + "?id=" + this.state.deleteID)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.popupClose()
                        this.successMessage(response.data.message)
                        this.GetPainScaleData()
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    this.errorMessage(error.message)
                })
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    render() {
        const { t } = this.props;

        const painLevel = {
            "(0-1)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "No Pain" },
            "(1-3)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "Mild Pain" },
            "(3-4)": { image: ImagePaths.moderateSmile.default, color: "#FFCD05", status: "Moderate" },
            "(5-7)": { image: ImagePaths.severeSmile.default, color: "#F8981D", status: "Severe" },
            "(7-9)": { image: ImagePaths.verySevereSmile.default, color: "#F26A22", status: "Very Severe" },
            "(9-10)": { image: ImagePaths.worstPainsmile.default, color: "#DA1A32", status: "Worst Pain Possible" },
        };

        const columns = [
            {
                field: 'pain_chart_date', headerName: t("DateTime"), flex: 0.333, headerAlign: "center", align: "center",
                renderCell: ({ row }) => {
                    let startDate = row?.pain_chart_date ? new Date(row.pain_chart_date) : "";
                    let date = DateTime.fromJSDate(startDate).toFormat("dd-MM-yyyy hh:mm a");
                    return (<Box component={'div'} emed_tid={`doc_pain_scale_left_date_cell_${row.id}`}>{date ? (date) : '-'}</Box>)
                }
            },
            {
                field: "pain_level", flex: 0.333, headerName: t("PainLevel"), headerAlign: "center", align: "center",
                renderCell: ({ row }) => {
                    const painItem = painLevel[row?.pain_level];
                    return (painItem ? <Box component={'div'} sx={{ display: "flex", flexDirection: "row", gap: "0.5vw" }} emed_tid={`doc_pain_scale_left_pain_level_cell_${row.id}`}>
                        <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }} emed_tid={`doc_pain_scale_left_pain_level_text_${row.id}`}>{row?.pain_level ? row?.pain_level : '-'}</Typography>
                        <img className='emedhub_pain_range' src={painItem.image} />
                        <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }} emed_tid={`doc_pain_scale_left_pain_status_${row.id}`}>{painItem.status}</Typography>
                    </Box> : "-")
                }
            },
            {
                field: "action", flex: 0.333, headerName: t("Action"), headerAlign: "center", align: "center",
                renderCell: ({ row }) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"} emed_tid={`doc_pain_scale_left_action_cell_${row.id}`}>
                    <CommonEditButton testID={"pain_edit"} size={"1.5vw"} disable={this.props?.isLocked} onClick={() => this.onEditHandler(row)} />
                    <CommonDeleteButton testID={"pain_delete"} size={"1.5vw"} disable={this.props?.isLocked || this.state.deleteID === row?.id} onClick={() => this.onDeleteHandler(row)} />
                </Box>
            }
        ]
        return (
            <ShowComponents onIntersection={this.GetPainScaleData.bind(this)}>
                <Box height={'30vh'} overflow={'auto'} emed_tid="doc_pain_scale_left_container">
                    <DataGrid
                        emed_tid="doc_pain_scale_left_datagrid"
                        rows={this.state.painScaleList}
                        columns={columns}
                        getRowId={(row) => row['id']}
                        headerHeight={40}
                        hideFooter={true}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_DocNotes_nodata' emed_tid="doc_pain_scale_left_no_rows">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        disableSelectionOnClick
                    />
                </Box>
                {this.state.isErrorMsg && <ToastMsg
                    emed_tid="doc_pain_scale_left_error_toast"
                    severity={'error'}
                    msg={this.state.isErrorMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
                {this.state.successMsg && <ToastMsg
                    emed_tid="doc_pain_scale_left_success_toast"
                    severity={'success'}
                    msg={this.state.successMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
                {this.state.isDeleteClicked && <DeletePopup
                    emed_tid="doc_pain_scale_left_delete_popup"
                    DeletTitle={`${t("deleteMsg")} ${t("Pain Chart")}?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deletePainScale.bind(this)}
                />}
            </ShowComponents>
        )
    }
}
export default withTranslation()(DocPainScaleLeft)